import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { TARGET_AUDIENCE } from '../../constants';

export const { Types, Creators } = createActions({
  macrossegmentInit: [],
  macrossegmentRequest: [],
  macrossegmentSuccess: ['context', 'data'],
  macrossegmentError: ['err'],
  getMacrossegments: ['filter']
});

/** --------------------------------
 * Variable declarations
 * --------------------------------- */

const INITIAL_STATE = Immutable({
  data: [],
  [TARGET_AUDIENCE]: [],
  loading: false,
  error: false
});

/* Reducers Product */

export const init = state => state.merge({ data: [] });

export const request = state => state.merge({ loading: true });

export const success = (state, { context, data }) => state.merge({ [context]: data, error: false, loading: false });

export const error = state => state.merge({ loading: false, error: true });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.MACROSSEGMENT_INIT]: init,
  [Types.MACROSSEGMENT_REQUEST]: request,
  [Types.MACROSSEGMENT_SUCCESS]: success,
  [Types.MACROSSEGMENT_ERROR]: error
});